import React from 'react'

import ChevronRight from '@interco/icons/core/action-navigation/ic_chevron_right'
import { Colors } from '@utils/Colors'

import { Row, Container, Content, Header, Title, Subtitle, Description } from './styles'

interface OpportunityCardProps {
  title?: string
  subtitle: string
  description: string
  onClick?: () => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void
  ariaLabel?: string
}

const OpportunityCard = ({
  title = 'Oportunidade',
  subtitle,
  description,
  onClick,
  onKeyDown,
  ariaLabel,
}: OpportunityCardProps & React.HTMLAttributes<HTMLButtonElement>) => (
  <Row>
    <Container
      type="button"
      role="link"
      onClick={onClick}
      onKeyDown={onKeyDown}
      aria-label={ariaLabel}
    >
      <Content>
        <Header>
          <Title>{title}</Title>
        </Header>
        <Subtitle>{subtitle}</Subtitle>
        <Description>{description}</Description>
      </Content>
      <ChevronRight width={24} height={24} color={Colors.GRAY400} />
    </Container>
  </Row>
)

export default OpportunityCard
